import React from 'react';
import webCore from '@happylife-a/web-core';
import webApp from '@happylife-a/web-app';
import { Flex, Text } from '@chakra-ui/react';

export default function PaymentInfo({ showTitle = true, paymentCardNumber, paymentProviderName }) {
  const { t } = webCore.contexts.useTranslation();

  return (
    <Flex flexDir="column" w="130px">
      {showTitle && <Text variant="sub-head-med">{t('Payment method')}</Text>}
      {paymentCardNumber ? (
        <Flex alignItems="center" gap={2}>
          <webApp.theme.icons.CardIcon w={6} h={6} fill="none" />
          <Flex flexDir="column" justifyContent="start">
            <Text variant="sub-head-reg" textAlign="left">
              {t(paymentProviderName)}
            </Text>
            <Text variant="body-reg-sm-bold" textAlign="left">
              {paymentCardNumber}
            </Text>
          </Flex>
        </Flex>
      ) : (
        <Text variant="sub-head-reg">{t(paymentProviderName)}</Text>
      )}
    </Flex>
  );
}
